import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPilone: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="pilone, maintenance"><path d="M9.02818 2.54396C9.12017 2.22198 9.41446 2 9.74932 2H14.2493C14.5842 2 14.8785 2.22198 14.9705 2.54396L16.815 9H7.18359L9.02818 2.54396Z" fill="currentColor"/><path d="M6.75558 10.5L5.89844 13.5H18.1013L17.2442 10.5H6.75558Z" fill="currentColor"/><path d="M18.53 15H5.46999L4.18427 19.5H2.75C2.33579 19.5 2 19.8358 2 20.25C2 20.6642 2.33579 21 2.75 21H21.25C21.6642 21 22 20.6642 22 20.25C22 19.8358 21.6642 19.5 21.25 19.5H19.8157L18.53 15Z" fill="currentColor"/></CentralIconBase>;
};

export default IconPilone;
